module.exports = __webpack_public_path__ + "img/12.b5d0577c.png";